import React from 'react';
import * as _ from 'lodash-es';
import AvatarStack from '../components/AvatarStack';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import type { AvatarStack_UsersFragment } from '../graphql/generated/graphql';
import { useGetUser } from '../user/useAllUsers';

const GROUP_FRAGMENT = gql(`
  fragment GroupCardAvatarStack_group on Group {
    id
    members {
      ...useGetUser_user
    }
    owners {
      ...useGetUser_user
    }
  }
`);

interface GroupCardAvatarStackProps {
  group: DocumentType<typeof GROUP_FRAGMENT>;
}

function sortAndRotateById(users: AvatarStack_UsersFragment[], id: string) {
  const sortedUsers = _.sortBy(users, (user) => user.id);

  const index = _.sortedIndex(
    sortedUsers.map((user) => user.id),
    id,
  );

  return [...sortedUsers.slice(index), ...sortedUsers.slice(0, index)];
}

const GroupCardAvatarStack = ({ group }: GroupCardAvatarStackProps) => {
  const getUser = useGetUser();
  const owners = group.owners.map(getUser);
  const members = group.members.map(getUser);
  const sortedOwners = sortAndRotateById(owners, group.id);
  const sortedMembers = sortAndRotateById(members, group.id);
  const users = [...sortedOwners, ...sortedMembers];

  return <AvatarStack users={users} limit={5} />;
};

export default GroupCardAvatarStack;
